import cn from 'classnames'
import React, { ComponentProps } from 'react'

type SnowflakeIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function SnowflakeIcon(props: SnowflakeIconProps) {
  const { className = '', ...rest } = props

  return (
    <svg
      className={cn('SnowflakeIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8 1v14M2 4.5l12 7M14 4.5l-12 7M8 1 6 3m2-2 2 2M8 15l-2-2m2 2 2-2M2 4.5l.2 2.7M2 4.5l2.7-.2M14 11.5l-.2-2.7M14 11.5l-2.7.2M14 4.5l-.2 2.7M14 4.5l-2.7-.2M2 11.5l.2-2.7M2 11.5l2.7.2"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
